import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRejectedStatusIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white",
			style: { mixBlendMode: "multiply" }
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8,
			cy: 8,
			r: 7.5,
			fill: "#D40B00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.4746 5.52588L5.5246 10.4754",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.4746 10.4751L5.5246 5.52561",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgRejectedStatusIcon);
export default ForwardRef;
